import {Component, computed, input, InputSignal, Signal, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-document-filename',
    templateUrl: './document-filename.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./document-filename.component.scss'],
})
export class DocumentFilenameComponent {
    public appTestTag: InputSignal<string | undefined> = input<string | undefined>('');
    public filename: InputSignal<string | undefined> = input<string | undefined>('');
    protected baseFileName: Signal<string>;
    protected fileExtension: Signal<string>;

    public constructor() {
        this.fileExtension = computed(() => {
            const filename = this.filename();
            if (!filename?.includes('.')) {
                return '';
            }

            return filename.split('.')
                .pop() ?? '';
        });

        this.baseFileName = computed(() => {
            const filename = this.filename();
            if (!filename) {
                return '';
            }

            if (!filename.includes('.')) {
                return filename;
            }

            const nameParts = filename.split('.');
            return nameParts.slice(0, -1)
                .join('.') + '.';
        });
    }
}
